hot = window.Handsontable # shortcut

# Create a custom editor and renderer for the Status cell type. This is mostly
# copied from the source for the Checkbox cell type.
# TODO: make this more dynamic??

# Create a blank editor, because all the work is done by renderer.
class StatusEditor extends hot.editors.BaseEditor
# I think CoffeeScript's extend is just as good as Handsontable's extend method
# StatusEditor = hot.editors.BaseEditor.prototype.extend()

    beginEditing: ->
        label = @TD.querySelector('span.label')
        if label
            label.click()

    finishEditing: ->
        undefined

    init: ->
        undefined

    open: ->
        undefined

    close: ->
        undefined

    getValue: ->
        undefined

    setValue: ->
        undefined

    focus: ->
        undefined

# register it with Handsontable
hot.editors.StatusEditor = StatusEditor
hot.editors.registerEditor 'status', hot.editors.StatusEditor


# create the renderer

clonableSPAN = document.createElement('SPAN')
clonableSPAN.className = 'label text-center'

statusRenderer = (instance, TD, row, col, prop, value, cellProperties) ->
    eventManager = hot.eventManager(instance)

    hot.Dom.empty(TD)

    activated_prop = instance.activated_prop ? 'active'
    completed_prop = instance.completed_prop ? 'is_complete'

    # determine the status
    active = instance.getDataAtRowProp(row, activated_prop)
    if not active or active is 'false'
        status = 'Inactive'
    else
        if instance.check_completion
            # only check placeability if the lineup has one or more corresponding SPPs
            is_complete = instance.getDataAtRowProp(row, completed_prop)
            if not is_complete or is_complete is 'false'
                status = 'Incomplete'

    # if it's not Inactive or Incomplete, it must be Active
    status ?= 'Active'

    # create the HTML
    SPAN = clonableSPAN.cloneNode(false) # this is faster than createElement
    switch status
        when 'Active'
            SPAN.className += ' label-success'
        when 'Incomplete'
            SPAN.className += ' label-warning'
        when 'Inactive'
            SPAN.className += ' label-important'

    SPAN.style.cursor = 'pointer'

    # This is faster than innerHTML. See
    # https://github.com/handsontable/handsontable/wiki/JavaScript-&-DOM-performance-tips
    hot.Dom.fastInnerText(SPAN, status)
    TD.appendChild(SPAN)

    # event listeners
    if cellProperties.readOnly
        eventManager.addEventListener SPAN, 'click', (event) ->
            event.preventDefault()
    else
        eventManager.addEventListener SPAN, 'click', (event) ->
            row_active = instance.getDataAtRowProp(row, activated_prop)
            if not row_active or row_active is 'false'
                instance.setDataAtRowProp(row, activated_prop, true)
            else
                instance.setDataAtRowProp(row, activated_prop, false)

        eventManager.addEventListener SPAN, 'mousedown', (event) ->
            # otherwise can confuse cell mousedown handler
            hot.helper.stopPropagation(event)

        eventManager.addEventListener SPAN, 'mouseup', (event) ->
            # otherwise can confuse cell dblclick handler
            hot.helper.stopPropagation(event)

    # hook to handle space and enter events on selected cells
    if not instance.StatusRenderer?.beforeKeyDownHookBound
        instance.StatusRenderer =
            beforeKeyDownHookBound: true

        instance.addHook 'beforeKeyDown', (event) ->
            hot.Dom.enableImmediatePropagation(event)

            if event.keyCode in [hot.helper.keyCode.SPACE, hot.helper.keyCode.ENTER]

                selRange = instance.getSelectedRange()

                # We may not have anything selected
                if selRange isnt undefined
                    topLeft = selRange.getTopLeftCorner()
                    bottomRight = selRange.getBottomRightCorner()

                    for sel_row in [topLeft.row..bottomRight.row]
                        for sel_col in [topLeft.col..bottomRight.col]
                            cell = instance.getCell(sel_row, sel_col)
                            meta = instance.getCellMeta(sel_row, sel_col)

                            labels = cell.querySelectorAll('span.label')

                            if labels.length > 0 and not meta.readOnly
                                if not event.isImmediatePropagationStopped()
                                    event.stopImmediatePropagation()
                                    event.preventDefault()

                                for label in labels
                                    row_active = instance.getDataAtRowProp(sel_row, 'active')
                                    if not row_active or row_active is 'false'
                                        instance.setDataAtRowProp(sel_row, activated_prop, true)
                                    else
                                        instance.setDataAtRowProp(sel_row, activated_prop, false)


# register it with Handsontable
hot.renderers.StatusRenderer = statusRenderer
hot.renderers.registerRenderer('status', statusRenderer)


# create the cell type

hot.StatusCell =
    editor: hot.editors.StatusEditor
    renderer: hot.renderers.StatusRenderer

# register it with Handsontable
hot.cellTypes.status = hot.StatusCell
